import axiosRequest from '../constants/axios-request'

export const claimCertificate = (progressId: string): Promise<number> =>
  axiosRequest
    .post('/certif', { progressId })
    .then((result) => result.status)
    .catch((error) => error.response.status)
